import React, { Component } from 'react';
import Api from './../../Global/Modules/Api';

class Text extends Component {
  constructor() {
    super();
    this.state = {
      Title: '',
      Description: ''
    }
  }

  rawMarkup() {
    var rawMarkup = this.state.Description
    return { __html: rawMarkup };
  }

  componentDidMount() {
    
    const FETCH_URL = 'api/pages/' + this.props.url.split("/").join("zxyz");
    Api.GetApi(FETCH_URL).then(data => {
      this.setState({ Title: data.title, Description: data.description })
    });
  }

  render() {


    return (

      <div className="route">
        <div>
          <h1 className="pageTitle">
            {this.state.Title}
          </h1>
        </div>
        <div>
          <p dangerouslySetInnerHTML={this.rawMarkup()} />

        </div>
      </div>
    );
  }
}

export default Text;



// WEBPACK FOOTER //
// ./src/components/Global/Modules/Text.js